import { render, staticRenderFns } from "./CustomerPage.vue?vue&type=template&id=2ba23966&scoped=true&"
import script from "./CustomerPage.vue?vue&type=script&lang=ts&"
export * from "./CustomerPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba23966",
  null
  
)

export default component.exports